import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { AUDIT_TRAIL_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetAuditTrailGridProps {
  communityId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getAuditTrailGrid = async (communityId: string, data: any) =>
  await axiosAuth.post(`${AUDIT_TRAIL_API(communityId)}/grid`, data);

const useGetAuditTrailGrid = ({
  communityId,
  data,
  queryParams,
}: UseGetAuditTrailGridProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["audit-trail-grid"],
    queryFn: () => getAuditTrailGrid(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetAuditTrailGrid;
